import { Box, Typography, Link } from '@mui/material'
import { NavBar } from './Navigation'
import { useComponentSizeAndPosition } from '../shared/utils'
import { DVD } from './DVD'
import { LoadingPicture } from '../shared/LoadingPicture'

export function Travel() {
  const isMobile = window.innerWidth < 768

  return isMobile ? <TravelMobile /> : <TravelDesktop />
}

function TravelMobile() {
  const { boxRef } = useComponentSizeAndPosition()

  return (
    <Box
      ref={boxRef}
      sx={{
        width: '100vw',
        height: '100vdh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          padding: '10px',
          bottom: 0,
          width: '100%',
          zIndex: 1,
          backgroundColor: 'rgba(255, 255, 255, 1.0)',
        }}
      >
        <NavBar direction="row" />
      </Box>
      <LoadingPicture
        imageId="wedding_travel.jpg"
        size="medium"
        stage="prod"
        style={{
          padding: '0px 20px',
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
        }}
      />
      <Box sx={{ padding: '40px' }}>
        <BodyText />
      </Box>
    </Box>
  )
}

function TravelDesktop() {
  const { width, height, boxRef } = useComponentSizeAndPosition()

  return (
    <Box ref={boxRef} sx={{ position: 'relative', height: '100vh' }}>
      {width && height && (
        <DVD
          containerHeight={height}
          containerWidth={width}
          initialX={width - 200}
          initialY={height - 400}
          radius={100}
          text="Big yellow button"
        />
      )}
      <Box sx={{ padding: '10px' }}>
        <NavBar direction="row" />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          padding: '20px',
        }}
      >
        <LoadingPicture
          imageId="wedding_travel.jpg"
          size="medium"
          stage="prod"
          style={{
            // height: 'calc(100vh - 100px)',
            width: '700px',
            minWidth: '400px',
            objectFit: 'cover',
            marginRight: '30px',
          }}
        />
        <Box sx={{ width: '300px', padding: '20px' }}>
          <BodyText />
        </Box>
      </Box>
    </Box>
  )
}

function BodyText() {
  return (
    <>
      <Typography variant="body1" paragraph fontWeight="bold">
        Scribner’s catskill lodge is a ~2.5hr drive from New York City. The best
        way to get there is by car. If you’re flying into the area, EWR is the
        closest and most accessible major airport.
      </Typography>

      <Typography variant="body1" paragraph fontWeight="bold">
        The ceremony will take place at Hayfield, which is a 15 min drive from
        Scribner's. We will have shuttles to ferry everyone to and from Hayfield
        on Saturday.
      </Typography>

      <Typography variant="body1" paragraph fontWeight="bold">
        Most people will be staying at the main lodge in Scribner’s, but it’s
        totally up to you if you’d like to stay somewhere else. Please use this{' '}
        <Link
          href="https://app.mews.com/distributor/1921b5b6-c608-49a8-a13b-af6400e66872?mewsAvailabilityBlockId=108350a8-36e6-42ab-93fe-b1c0003140d9&mewsStart=2025-09-05&mewsEnd=2025-09-07"
          target="_blank"
          rel="noopener"
          underline="hover"
        >
          booking link
        </Link>
        . Our unofficial afterparty will likely be in Tam & Jason’s room at the
        Rounds, a ~7 min walk from the main lodge through an uphill forest path.
      </Typography>
    </>
  )
}
